module.exports = __webpack_public_path__ + "static/media/4-4-do-nebe-vzal.ff5b0246.jpg";